import { OrdersWithoutWeightApiAdapter } from '../adapters/OrdersWithoutWeightApiAdapter';
import { Filters } from '../models/Filters';
import { OrdersWithoutWeightPage } from '../models/Order';

export class Service {
  constructor(private apiAdapter: OrdersWithoutWeightApiAdapter) {}

  async getPaginated(filters: Filters = {}): Promise<OrdersWithoutWeightPage> {
    return this.apiAdapter.getOrdersWithoutWeightPaginated(filters);
  }
}

